import React, { Component } from 'react';
import { QueryRenderer, graphql } from 'react-relay';
import environment from '../../data/environment';
import { FormattedHTMLMessage } from 'react-intl';
import ReportList from './components/ReportList';
import CenteredErrorMessage from '../../components/CenteredErrorMessage';
import CenteredLoadingAnimation from '../../components/CenteredLoadingAnimation';

class Reports extends Component {
  render() {
    return (
      <QueryRenderer
        environment={environment}
        query={graphql`
          query ReportsQuery {
            ...ReportList_query
          }
        `}
        render={({ error, props }) => {

          if (error) {
            console.error(error);

            return (
              <CenteredErrorMessage>
                <FormattedHTMLMessage id="error.couldNotFetch" />
                <br /><hr /><div>{error.message}</div>
                <br /><div>{error.stack}</div>

              </CenteredErrorMessage>
            );
          } else if (props) {
            return <ReportList query={props} />;
          } else {
            return <CenteredLoadingAnimation />;
          }
        }}
      />
    )
  }
}

export default Reports;



// WEBPACK FOOTER //
// ./src/scenes/Reports/Reports.js